import React, { useState } from "react";
import axios from 'axios';
import { BASEURL } from "../Config";
import Footer from "../components/Footer";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import { useSelector } from "react-redux";
import { useHistory, NavLink } from 'react-router-dom';
import swal from 'sweetalert';

const AddElpChapters = () => {
    const [data, setData] = useState([{ name: "" }]);
    const classes = useSelector(state => state.class);
    const history = useHistory();

    const handleChange = (e, idx) => {
        const updatedData = [...data];
        updatedData[idx][e.target.name] = e.target.value;
        if (e.target.value === "") {
            updatedData[idx]['nameError'] = true;
        } else {
            delete updatedData[idx]['nameError'];
        }
        setData(updatedData);
    };

    const handleOnAddChapter = (e) => {
        e.preventDefault();
        setData([...data, { name: "" }]);
    };

    const handleOnDeleteChapter = (e, idx) => {
        e.preventDefault();
        const updatedData = data.filter((_, index) => index !== idx);
        setData(updatedData);
    };

    const validateData = () => {
        let error = false;
        const updatedData = data.map((item) => {
            if (item.name === "") {
                error = true;
                return { ...item, nameError: true };
            }
            return item;
        });
        setData(updatedData);
        return error;
    };

    const handleSubmit = () => {
        if (validateData()) {
            swal('Error in Adding Chapters', 'Fill the required fields', 'error');
        } else {
            // console.log('history.location.state', history.location.state)
            const cid = history.location.state ? history.location.state.bid : classes.uuid;
            // console.log('cid', history.location.state.bid)
            const chaptersData = data.map((item) => ({ ...item, class_uuid: cid }));
            console.log('chaptersData', chaptersData)
            axios.post(`${BASEURL}/api/v1/elp/chapters/save-all`, chaptersData)
                .then(res => {
                    if (res.status === 200) {
                        swal("Success", "Chapters Added successfully", "success")
                            .then(() => {
                                history.push({
                                    pathname: '/elpChapters',
                                    state: { bid: cid }
                                });
                            });
                    }
                })
                .catch((err) => {
                    swal('Error in Adding Chapters', err.response?.data || 'Unknown error', 'error');
                });
        }
    };

    return (
        <div id="wrapper">
            <Sidebar act="classes" />
            <div className="content-page">
                <div className="content">
                    <Topbar act="Add Elp Chapters" breadcrumbItems={["ELP", { label: 'Classes', path: '/classes' }, { label: 'Chapters', path: '/elpChapters' }, "Add New Chapters"]} />
                    <div className="container-fluid main-container">
                        <div className="row">
                            <div className="col-12">
                                <div className="card main-card">
                                    <div className="card-body">
                                        <h4 className="page-title">Class name: {classes.name}</h4>
                                        {data.map((item, idx) => (
                                            <div className="row" key={idx}>
                                                <div className="col-xl-6">
                                                    <div className="mb-3">
                                                        {idx === 0 && <label htmlFor="chaptername" className="form-label">Name of the chapter</label>}
                                                        <input
                                                            type="text"
                                                            id="chaptername"
                                                            className="form-control"
                                                            onChange={(e) => handleChange(e, idx)}
                                                            name="name"
                                                            placeholder="Enter Chapter Name"
                                                            value={item.name}
                                                        />
                                                        {item.nameError && <p className="errTxt">* required</p>}
                                                    </div>
                                                </div>
                                                <div className="col-xl-3">
                                                    {idx === 0 && <label htmlFor="actions" className="form-label">Actions</label>}
                                                    <div className="mb-3">
                                                        <button className="btn btn-danger" onClick={(e) => handleOnDeleteChapter(e, idx)}>
                                                            <i className="mdi mdi-minus-circle" /> Delete
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                        <div className="mb-2">
                                            <button className="btn btn-success" onClick={handleOnAddChapter}>
                                                <i className="mdi mdi-plus-circle" /> Chapter
                                            </button>
                                        </div>
                                        <button type="submit" className="btn btn-customprimary" onClick={handleSubmit}>
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </div>
    );
};

export default AddElpChapters;
